import { EColors, EFonts, EVariables } from "libs/style/w24_styling"
import React, { useEffect, useState } from "react"
import TextareaAutosize from "react-textarea-autosize"
import styled from "styled-components/macro"
import { useDebounce } from "usehooks-ts"

interface Props {
  label: string
  value: string
  multiple?: boolean
  rows?: number

  placeholder?: string
  onChange?: (value: string) => void
  onBlur?: () => void
  onDebounce?: (value: string) => void
  className?: string
}

export const FieldInput = (props: Props): JSX.Element => {
  const [value, setValue] = useState<string>(props.value)
  const debouncedValue = useDebounce(value, 250)

  useEffect(() => {
    if (props.value !== value) {
      setValue(props.value)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.value])

  useEffect(() => {
    if (props.onChange) {
      props.onChange(value)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  useEffect(() => {
    if (props.onDebounce) {
      props.onDebounce(debouncedValue)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue])

  return (
    <S_FieldInput className={props.className}>
      <S_Label>
        <S_LabelText>{props.label}</S_LabelText>
        <TextareaAutosize
          value={value}
          onChange={e => {
            setValue(e.target["value"])
          }}
          onBlur={props.onBlur}
          maxRows={props.rows}
          minRows={props.rows}
        />
      </S_Label>
    </S_FieldInput>
  )
}

export const S_FieldInput = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  textarea {
    width: 100%;
    background-color: ${EColors.LIGHT};
    border-radius: ${EVariables.Radius1};
    color: ${EColors.DARK2};
    font-family: ${EFonts.Medium2};
    font-size: 14px;
    line-height: 30px;
    padding: 8px 20px;
    color: ${EColors.DARK};
    width: 100%;
    resize: none;
    outline: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }
  @media only screen and (min-width: 1260px) {
    textarea {
      font-size: 16px;
      line-height: 30px;
      padding: 12px 25px;
      min-width: 45px;
    }
  }
`

const S_Label = styled.label`
  display: flex;
  flex-direction: column;
  gap: 20px;
  @media only screen and (min-width: 1260px) {
    gap: 22px;
  }
`

const S_LabelText = styled.div`
  color: ${EColors.DARK};
  font-family: ${EFonts.Medium};
  font-size: 14px;
  @media only screen and (min-width: 1260px) {
    font-size: 18px;
  }
`
